<template>
    <div>
        {{countdown}}
    </div>
</template>

<script>
    import TimeStamp from "../../services/timeStamp";

    export default {
        name: "countdown",
        props: ['target', 'startDate', 'durationHours'],
        computed: {
            targetDate(){
                if ( this.target ) {
                    const localUTC = this.target - new Date().getTimezoneOffset()* 60 * 1000;
                    return new Date(localUTC);
                } else if (this.startDate) {
                    const UTC = TimeStamp.getTimestampForDateUncorrected(null, this.startDate) + this.durationHours*60*60*1000;
                    return new Date(UTC)
                } else {
                    return null;
                }
            },
        },
        data: () => ({
            x: null,
            countdown: '',
        }),
        created(){
            console.log ("CREATED: Countdown target" );
            if ( this.targetDate ) { this.setCountdown() }
        },
        destroyed(){
            clearInterval(this.x);
        },
        methods: {
            setCountdown(){
// Update the count down every 1 second
                this.x = setInterval( () => {
                    console.log ("countdown" );
                // Get today's date and time
                    const now = new Date().getTime();
                // Find the distance between now and the count down date
                    const distance = this.targetDate - now;
                // Time calculations for days, hours, minutes and seconds
                    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + days * 24;
                    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toLocaleString('de-DE', {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    });
                    const seconds = Math.floor((distance % (1000 * 60)) / 1000).toLocaleString('de-DE', {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    });
                // Output the result
                    this.countdown = hours + "h "
                        + minutes + "m " + seconds + "s";
                // If the count down is over, write some text
                    if (distance < 0) {
                        clearInterval(this.x);
                        this.countdown = "verspätet";
                        this.$emit('expired');
                    }
                }, 1000);
            }
        },
        watch: {
            target(){
                console.log ("WATCH: Countdown target" );
                this.setCountdown()
            }
        }
    }
</script>

<style scoped>
    div {  white-space:nowrap;}
</style>